import { SectionAtmosphere } from '../layout/HoldingBackdrop';

export default function Partners() {
  const partners = [
    { name: 'Maymont Energy', color: '#5eead4' },
    { name: 'Wärtsilä', color: '#7dd3fc' },
    { name: 'Enel Brasil', color: '#86efac' },
    { name: 'Oracle', color: '#fca5a5' },
    { name: 'Zero Labs', color: '#d6d3d1' },
    { name: 'Drax Group', color: '#93c5fd' },
    { name: 'Gruppo STG', color: '#a5b4fc' },
    { name: 'Ormat Technologies', color: '#6ee7b7' },
  ];

  return (
    <section className="relative isolate overflow-hidden px-5 py-24 md:px-8 md:py-28" aria-label="Partners">
      <SectionAtmosphere variant="partners" />
      <div className="relative z-10 mx-auto max-w-7xl">
        <h2 className="animate-on-scroll text-center font-semibold tracking-[-0.04em] text-[#f1f5ec]/90 md:text-4xl">
          Trusted by industry leaders
        </h2>
        <div className="animate-on-scroll mt-12 flex flex-wrap justify-center gap-x-12 gap-y-8">
          {partners.map((partner) => (
            <div key={partner.name} className="group relative">
              <span
                className="cursor-default text-xs font-semibold uppercase tracking-[0.22em] opacity-70 transition-all duration-300 group-hover:opacity-100"
                style={{ color: partner.color }}
              >
                {partner.name}
              </span>
              <div
                className="absolute -bottom-1 left-0 h-px w-0 transition-all duration-300 group-hover:w-full"
                style={{ backgroundColor: partner.color }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
